import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import styles from "./Tabs.styles";
import { Paper } from "@mui/material";

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

interface StyledTabProps {
  label: string;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

type TabItemType = "Entity" | "Object";

export  type TabItem = {
  type: TabItemType;
  content: React.ReactNode;
}

export type CustomTabsProps = {
  items: TabItem[];
}

const tabProps = (index: number) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box id="box-tabPanel" sx={styles.tabPanel}>{children}</Box>}
    </div>
  );
};

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    // TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    slotProps={{
      indicator: { children: <span className="MuiTabs-indicatorSpan" /> },
    }}
    variant="fullWidth"
    indicatorColor="secondary"
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    marginBottom: 5,
  },
  "& .MuiTabs-indicatorSpan": {
    width: "95%",
    backgroundColor: "#fff",
  },
});

const StyledTab = styled((props: StyledTabProps) => (
  <Tab centerRipple {...props} />
))(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.secondary.light,
  "&.Mui-selected": {
    color: "#fff",
  },
  "&.Mui-focusVisible": {
    backgroundColor: theme.palette.secondary.light,
  },
  padding: theme.spacing(1),
  [theme.breakpoints.up("xs")]: {
    fontSize: theme.typography.pxToRem(12),
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: theme.typography.pxToRem(14),
  },
  [theme.breakpoints.up("md")]: {
    padding: "18px 16px",
    fontSize: theme.typography.pxToRem(16),
  },
}));

const CustomTabs:React.FC<CustomTabsProps> = ({items}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setValue(index);
  };

  return (
    <Paper sx={styles.contentHolder}>
      <AppBar position="relative" sx={styles.dataBox}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="custom tabs"
        >
          {items.map((item, index: number) => (
            <StyledTab key={item.type} label={item.type} {...tabProps(index)} />
          ))}
        </StyledTabs>
      </AppBar>
      <SwipeableViews
        axis="x-reverse"
        // axis={"direction" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {items.map((item, index: number) => (
          <TabPanel value={value} index={index} key={index}>
            {item.content}
          </TabPanel>
        ))}
      </SwipeableViews>
    </Paper>
  );
};

export default CustomTabs;
